import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
const OAuthCallback = () => {
    useEffect(() => {
        // Extract OAuth response parameters from URL
        const urlParams = new URLSearchParams(window.location.search);
        const params = {};
        urlParams.forEach((value, key) => {
            params[key] = value;
        });
        // Send the response back to the parent window
        if (window.opener) {
            window.opener.postMessage({
                type: 'OAUTH_RESPONSE',
                payload: params,
            }, '*');
            // Close the popup window
            window.close();
        }
        else {
            console.error('No opener window found for OAuth callback');
        }
    }, []);
    return (_jsx("div", { className: "flex items-center justify-center min-h-screen bg-gray-50", children: _jsxs("div", { className: "text-center", children: [_jsx("div", { className: "mb-4", children: _jsx("div", { className: "animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto" }) }), _jsx("p", { className: "text-gray-600", children: "Processing authentication..." }), _jsx("p", { className: "text-sm text-gray-500 mt-2", children: "This window will close automatically." })] }) }));
};
export default OAuthCallback;
